import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {SearchUserService} from "../services/search-user.service";
import {AuthService} from "../../@core/auth/auth.service";
import {debounceTime, distinctUntilChanged, filter, startWith, switchMap, takeUntil, tap} from "rxjs/operators";
import {Router} from "@angular/router";
import {environment} from "../../../environments/environment";
import {IUserShort} from "../../@core/interfaces/user/user.interface";
import {AuthUserService} from "../services/auth/auth-user.service";
import {combineLatest, Subject} from "rxjs";
import {canAccessVipUi} from "../constants/vip-access";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  public isGoFast: boolean = environment.projectName === 'CSGOFAST';
  public canAccessVip: boolean = false;
  public searchType: any[] = [
    {value: 'fast_id', viewValue: 'USER ID'},
    {value: 'ref', viewValue: 'REF'},
    {value: 'name', viewValue: 'NAME'},
    {value: 'steamid64', viewValue: 'STEAM ID'}
  ];

  public searchResult: IUserShort[] = [];
  public loading: boolean = false;
  public navigatorIsOpened: boolean = false;
  public searchForm: UntypedFormGroup;
  private readonly destroyed$: Subject<void> = new Subject<void>();

  constructor(private searchUserService: SearchUserService,
              private router: Router,
              private authService: AuthService,
              private authUserService: AuthUserService,
              private fb: UntypedFormBuilder) {
    this.searchForm = this.fb.group({
        inputQuery: new UntypedFormControl(''),
        searchType: new UntypedFormControl(this.searchType[0].value, {nonNullable: true})
      }
    )
  }

  ngOnInit(): void {
    this.authUserService.user$
      .pipe(
        takeUntil(this.destroyed$),
        tap((user) => this.canAccessVip = canAccessVipUi(environment.projectName, user)),
      )
      .subscribe();

    const inputQueryControl = this.searchForm.get('inputQuery')!;
    const searchTypeControl = this.searchForm.get('searchType')!;

    combineLatest([
      inputQueryControl.valueChanges.pipe(startWith(inputQueryControl.value)),
      searchTypeControl.valueChanges.pipe(startWith(searchTypeControl.value)),
    ])
      .pipe(
        takeUntil(this.destroyed$),
        tap(() => this.searchResult = []),
        filter(([query]) => !!query),
        tap(() => {
          this.loading = true;
          this.searchUserService.searchResult.next([]);
        }),
        debounceTime(300),
        distinctUntilChanged(([previousQuery, previousType], [query, type]) => previousQuery === query && previousType === type),
        switchMap(([query, type]: [string, string]) => this.searchUserService.searchUser(query, type)))
      .subscribe((users: IUserShort[]) => {
        this.loading = false;
        this.searchUserService.searchResult.next(users);
        this.searchResult = users;
      })
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  async onEnter(event: any): Promise<any> {
    await this.router.navigate(['/', event.value]);
    this.searchResult = [];
    this.searchForm.reset();
  }

  checkValue(event: any): void {
    const searchType: string = this.searchForm.get('searchType')?.value;

    switch (searchType) {
      case 'fast_id':
        return String.fromCharCode(event.charCode).match(/^[0-9\s]*$/)
          ? event.CharCode
          : event.preventDefault();
      case 'ref':
        return String.fromCharCode(event.charCode).match(/^[0-9a-zA-Z\s]*$/)
          ? event.CharCode
          : event.preventDefault();
      default:
        return event.CharCode;
    }
  }

  clearInput(): void {
    this.searchResult = [];
    this.searchUserService.searchResult.next([]);
  }

  logout(): void {
    this.authService.logout();
  }

  public toggleNavigator(): void {
    this.navigatorIsOpened = !this.navigatorIsOpened;
  }

  public navigatorEvent(component?: string): void {
    // switch (component) {
    //   case 'notifications': {
    //     this.toggleNotifications();
    //     break;
    //   }
    // }
    this.closeNavigator();
  }

  public closeNavigator(): void {
    this.navigatorIsOpened = false;
  }

}
